var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M2.5 8.20603C2.5 7.49193 2.80537 6.81192 3.33909 6.3375L7.78545 2.38518C9.04841 1.26256 10.9516 1.26256 12.2145 2.38518L16.6609 6.3375C17.1946 6.81192 17.5 7.49193 17.5 8.20603V15C17.5 16.841 16.0076 18.3334 14.1667 18.3334H5.83333C3.99238 18.3334 2.5 16.841 2.5 15V8.20603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dark",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7085 15C7.7085 14.6548 7.98832 14.375 8.3335 14.375H11.6668C12.012 14.375 12.2918 14.6548 12.2918 15C12.2918 15.3452 12.012 15.625 11.6668 15.625H8.3335C7.98832 15.625 7.7085 15.3452 7.7085 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.afc2de85f1bcaf48814815e2afc3a4a7.svg";
export { ForwardRef as ReactComponent };